/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerAgentService = {
  /**
   * Get Screen data
   *
   * */
  async getByCustomerCode(customerCode, select) {
    const requestScreenData = {
      url: "api/CustomerAgent",
      expand: "Supplier($select=Name)",
      top: "1",
      filter: `CustomerCode eq '${customerCode}'`,
    };

    if (select) requestScreenData.select = select;

    return await ApiService.oDataGet(requestScreenData);
  },

  async saveCustomerAgent(isNewAgent, customerAgent) {
    var payload = customerAgent;
    var url = "api/CustomerAgent";

    if (isNewAgent) return await ApiService.post(url, payload);
    else
      return await ApiService.patch(
        url,
        customerAgent.CustomerCode,
        payload,
        "String"
      );
  },
};

export { CustomerAgentService };
